import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users } from 'lucide-react';
/**
 * Easy to edit: tweak the messages or the rotation interval here.
 */
const MESSAGES = ['127 personas comenzaron hoy', '312 descargas esta semana', '84 personas viendo esta página ahora'];
const ROTATE_MS = 4000;
export function ActivityBadge() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(i => (i + 1) % MESSAGES.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, []);
  return <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full glass-panel border border-white/10" data-id="element-18">
      {/* Pulsing live dot */}
      <span className="relative flex h-2 w-2 shrink-0" data-id="element-19">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" data-id="element-20" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400" data-id="element-21" />
      </span>

      <Users className="w-3.5 h-3.5 text-gray-400 shrink-0" data-id="element-22" />

      <div className="relative h-5 min-w-[200px] sm:min-w-[230px] overflow-hidden" data-id="element-23">
        <AnimatePresence mode="wait" data-id="element-24">
          <motion.span key={index} initial={{
          y: 10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -10,
          opacity: 0
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="absolute inset-0 flex items-center text-xs sm:text-sm font-medium text-gray-300 whitespace-nowrap" data-id="element-25">
            {MESSAGES[index]}
          </motion.span>
        </AnimatePresence>
      </div>
    </div>;
}